import { render } from "./TermsAndPrivacyContentModals.vue.ts?vue&type=template&id=7ef6b24f&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentModals.vue?vue&type=template&id=7ef6b24f&scoped=true&ts=true"
import script from "./TermsAndPrivacyContentModals.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentModals.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndPrivacyContentModals.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentModals.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndPrivacyContentModals.vue.scss?vue&type=style&index=0&id=7ef6b24f&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentModals.vue?vue&type=style&index=0&id=7ef6b24f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef6b24f"],['__file',"src/apps/merchant3/components/customer-registration/terms-and-privacy/TermsAndPrivacyContentModals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ef6b24f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ef6b24f', __exports__)) {
    api.reload('7ef6b24f', __exports__)
  }
  
  module.hot.accept("./TermsAndPrivacyContentModals.vue.ts?vue&type=template&id=7ef6b24f&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TermsAndPrivacyContentModals.vue?vue&type=template&id=7ef6b24f&scoped=true&ts=true", () => {
    api.rerender('7ef6b24f', render)
  })

}


export default __exports__